import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import CustomIconButton from '../CustomIconButton';

import icons from '../../utils/assets/icons';

import './index.scss';

export default function Modal({ onClose, children }) {
  useEffect(() => {
    function closeOnEscape({ key }) {
      if (key === 'Escape') {
        onClose();
      }
    }

    window.addEventListener('keyup', closeOnEscape);

    return function cleanup() {
      window.removeEventListener('keyup', closeOnEscape);
    };
  }, []);

  return (
    <div
      className="Modal"
      onWheel={e => {
        e.preventDefault();
      }}
    >
      <div className="Modal__background" onClick={onClose} />
      <div
        className="Modal__box"
        onWheel={e => {
          e.stopPropagation();
        }}
      >
        <div className="Modal__cross">
          <CustomIconButton
            alt="close modal"
            onClick={() => {
              onClose();
            }}
            src={icons.x}
            title="Close"
          />
        </div>

        <div className="Modal__content">{children}</div>
      </div>
    </div>
  );
}

Modal.propTypes = {
  onClose: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
};
